<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <Breadcrumb
            :items="[{ name: 'Home', url: '/dashboard' }]"
            :currentItem="i18n('Transferências')" />
          <h1 class="max">{{ i18n('Transferências') }}</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 justify-space-between px-3>
          <v-flex xs2 md2>
            <DefaultFilterDate ref="filterDate" @reload="this.setFilterDate" />
          </v-flex>
          <v-flex xs2 md2>
            <v-select
              v-model="filterStatus"
              :items="filterStatusItems"
              label="Status"
              outline
              height="50"></v-select>
          </v-flex>
          <v-flex xs2 md4>
            <v-text-field
              :error="error"
              :loading="loading"
              v-model="wireId"
              box
              append-icon="search"
              class="search-filter"
              placeholder="Pesquisar por ID"></v-text-field>
          </v-flex>
          <v-flex style="display: flex;" xs5 md3 lg2>
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
              Filter
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12 mt-3>
          <div v-if="loaded == 'not_loaded'">{{ i18n('Carregando transferências...') }}</div>
          <div v-if="loaded == 'error'">{{ i18n('Algo errado. Não foi possível carregar as transferências.') }}</div>
          <div v-if="loaded == 'not_authorized'">{{ i18n('Não foi possível carregar as transferências. Você não foi autorizado.') }}</div>
          <div v-if="loaded == 'transaction_id_error'">{{ i18n('Não foi possível carregar a transação. Verifique o ID informado.') }} ({{ this.wireId }})</div>
          <transition name="fade">
            <v-layout row wrap>
              <v-flex xs12 id="table-wires">
                <DefaultDataTable
                  :headers="headers"
                  :items="records"
                  :loading="loading"
                  :no-data-text="i18n('Nenhuma transferência registrada')">
                  <template v-slot:items="props">
                    <tr @click.stop="selectRecord(props.item, props.index)">
                      <td class="text-xs-left"><span>{{ insertedDate(props.item) }}</span> <span class="font-weight-light">{{ insertedTime(props.item) }}</span></td>
                      <td class="text-xs-left">
                        <span>{{ companyName(props.item) }}</span>
                        <br />
                        <span class="font-weight-light">{{ companyDocumentType(props.item) }} {{ companyDocumentMask(props.item) }}</span>
                      </td>
                      <td class="text-xs-left">
                        {{ longAccountName(props.item.to_bank_account) }}
                      </td>
                      <td class="text-xs-left">
                        {{ wireStatus(props.item) }}
                      </td>
                      <td class="text-xs-right">{{ l(props.item.value, props.item.currency) }}</td>
                    </tr>
                    <tr v-if="selectedIndex === props.index">
                      <td colspan="5">
                        <v-layout row wrap caption>
                          <v-flex xs6 pt-3>
                            <div v-if="transactionsLoaded == 'not_loaded'">{{ i18n('Carregando transações...') }}</div>
                            <div v-if="transactionsLoaded == 'error'">{{ i18n('Algo errado. Não foi possível carregar as transações.') }}</div>
                            <div v-if="transactionsLoaded == 'not_authorized'">{{ i18n('Não foi possível carregar as transações. Você não foi autorizado.') }}</div>
                            <div v-if="transactionsLoaded == 'empty'">
                              <div v-if='props.item.status == "canceled"'>
                                {{ i18n('As transações associadas foram canceladas.') }}
                              </div>
                              <div v-else>
                                {{ i18n('Não existem transações associadas.') }}
                              </div>

                            </div>
                            <span v-if="transactionsLoaded == 'ok'" class="nowrap subtitle rounded-chip">{{ i18n('Transações associadas') }}: {{ selectedRecord.bank_transactions.length }}</span>
                            <span v-if="transactionsLoaded == 'ok'" class="btn-bg-color nowrap rounded-chip" @click.prevent.stop="openInNewWindow(`#/receipt/${selectedRecord.id}`)">
                              {{ i18n('Baixar recibo') }}
                            </span>
                            <span v-if="showActionButtons(props.item)" class="nowrap wire_status rounded-chip small" @click.prevent.stop="updateBankAccount(props.item)">Atualizar e refazer</span>
                          </v-flex>
                          <v-flex xs12 pt-3>
                            <transition-group name="fade">
                              <transaction @transaction-click="onTransactionClick" :selectionDisabled="true" :record="transaction" v-for="transaction in selectedRecord.bank_transactions" :key="transaction.id" cursor-default />
                            </transition-group>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                </DefaultDataTable>
                <v-layout row
                  wrap
                  my-5>
                  <v-flex xs6
                    pr-2>
                    <v-btn class="btn-style ma-0 mr-2"
                      block
                      dark
                      @click="loadPreviousPageRecords"
                      v-show="hasPreviousPage"><v-icon left
                        dark>skip_previous</v-icon> {{ i18n('Mais Recentes') }}</v-btn>
                  </v-flex>
                  <v-flex xs6
                    pl-2>
                    <v-btn class="btn-style--secondary ma-0 mr-2"
                      block
                      dark
                      @click="loadNextPageRecords"
                      v-show="hasNextPage">{{ i18n('Mais Antigas') }} <v-icon right
                        dark>skip_next</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </transition>
        </v-flex>

        <bank-account-dialog :addBtn="false"
          mode="update"
          :errors="errors"
          :record="bank_account_dialog_record"
          :dialog="bank_account_dialog"
          @closeDialog="closeBankAccountDialog"
          @updateBankAccount="updateBankAccountItem" />
        <confirm-modal :dialog="confirmation_dialog"
          :title="confirmation_title"
          @onCancel="confirmation_dialog = false"
          @onConfirm="onConfirm">
          Você tem certeza?
        </confirm-modal>

      </v-layout>
    </v-container>
    <details-dialog :addBtn="false"
      :record="transactionDetails"
      :dialog="dialog"
      @closeDialog="closeDialog" />
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import Breadcrumb from "./components/Breadcrumb"
import DefaultDataTable from "./components/DefaultDataTable"
import utils from "./shared/Utils"
import TransactionWithScheduleItem from "./TransactionWithScheduleItem"
import CustomerScheduledBankTransactionDetailsDialog from "./CustomerScheduledBankTransactionDetailsDialog"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import WireItem from "./WireItem"
import BankAccountsDialog from "./BankAccountsDialog"
import ConfirmModal from './ConfirmModal'

export default {
  name: 'CustomerWireListNew',
  components: {
    layout: LeftBarLayout,
    Breadcrumb,
    DefaultDataTable,
    DefaultFilterDate,
    'transaction': TransactionWithScheduleItem,
    'details-dialog': CustomerScheduledBankTransactionDetailsDialog,
    'bank-account-dialog': BankAccountsDialog,
    'confirm-modal': ConfirmModal,
    'wire': WireItem
  },
  props: {
    record: {
      type: Object
    }
  },
  data(vm) {
    return {
      records: [],
      error: false,
      errors: {},
      loaded: 'not_loaded',
      transactionsLoaded: 'not_loaded',
      loading: false,
      reload: false,
      dialog: false,
      selectedTransaction: {},
      transactionDetails: {},
      selectedRecord: {},
      selectedIndex: null,
      last_id: null,
      previous_ids: [],
      bank_account_dialog_record: {
        bank: { name: '', code: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: 'cpf',
      },
      headers: [
        { text: vm.i18n('Data'), value: 'bank_name', align: 'left', sortable: false },
        { text: vm.i18n('Nome/Documento'), value: 'name', align: 'left', sortable: false },
        { text: vm.i18n('Conta destino'), value: 'account_destiny', align: 'left', sortable: false },
        { text: vm.i18n('Status'), value: 'status', align: 'left', sortable: false },
        { text: vm.i18n('Valor'), value: 'value_total', align: 'right', sortable: false }
      ],
      company_wire_actions_disabled: false,
      filterDate: null,
      wireId: null,
      filterStatus: "all",
      bank_account_dialog: false,
      confirmation_dialog: false,
      confirmation_title: '',
      filterStatusItems: [
        { text: vm.i18n('Todas'), value: 'all' },
        { text: vm.i18n('Sucesso'), value: 'success' },
        { text: vm.i18n('Aguardando confirmação'), value: 'waiting_confirmation' },
        { text: vm.i18n('Aguardando correção'), value: 'waiting_correction' },
        { text: vm.i18n('Aguardando nova tentativa'), value: 'waiting_retry' },
        { text: vm.i18n('Falha'), value: 'failed' }
      ],
      consolidateFilter: {
        filterDate: null,
        filterStatus: "all",
        filterWireId: null
      }
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.loadRecords()
  },
  watch: {
  },
  computed: {
    hasPreviousPage() {
      return this.previous_ids.length > 0
    },
    hasNextPage() {
      return this.records.length == 100
    },
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    resetForm() {
      this.bank_account_dialog_record = {
        bank: { name: '', code: '', swift: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: 'cpf',
      }
      this.errors = {}
    },
    closeBankAccountDialog() {
      this.bank_account_dialog = false
    },
    openInNewWindow(url) {
      window.open(url, '_blank')
    },
    insertedDate(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[0]
    },
    insertedTime(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[1]
    },
    companyName(record) {
      const receiver = record.to_bank_account.company
      return receiver.social_name || 'N/A'
    },
    companyDocumentType(record) {
      const receiver = record.to_bank_account.company
      const document_type = receiver.document_type || false
      if (!document_type) return ''
      return document_type.toUpperCase()
    },
    companyDocumentMask(record) {
      const receiver = record.to_bank_account.company
      const document_type = receiver.document_type || false
      if (!document_type) return ''
      return utils.mask(document_type, receiver.document_number)
    },
    longAccountName(account) {
      if (account === null) { return '' }
      return utils.longAccountName(account)
    },
    wireStatus(record) {
      if (record.status == 'success') {
        return this.i18n('Sucesso')
      }
      if (record.status == 'canceled') {
        return this.i18n('Cancelado')
      }
      if (record.status == 'waiting_confirmation') {
        return this.i18n('Aguardando confirmação')
      }
      if (record.status == 'waiting_correction') {
        return this.i18n('Aguardando correção')
      }
      if (record.status == 'waiting_retry') {
        return this.i18n('Aguardando nova tentativa')
      }
      if (record.status == 'failed') {
        return this.i18n('Falhou')
      }
      return record.status
    },
    reloadRecords() {
      if (this.loading) {
        this.reload = true
      } else {
        this.reload = false
        this.previous_ids = []
        this.last_id = null
        this.loadRecords()
      }
    },
    loadRecords() {
      if (this.loading) return

      this.resetToConsolidateFilter();

      let successCallback = (response) => {
        if (response.body.data) {
          this.records = response.body.data
          if (this.records.length === 0) {
            this.loaded = 'empty'
          } else {
            this.loaded = 'ok'
          }
        } else {
          this.loaded = 'error'
        }
        this.loading = false
        if (this.reload) {
          this.reloadRecords()
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else if (response.status === 422) {
          this.loaded = 'transaction_id_error'
        } else {
          this.loaded = 'error'
        }

        this.records = []
        this.loading = false

        if (this.reload) {
          this.reloadRecords()
        }
      }

      let token = this.$cookies.get('api_token')
      this.loading = true

      let params = {
        per_page: 100
      }

      if (this.last_id) {
        params.last_id = this.last_id
        params.per_page = 100
      }

      if (this.consolidateFilter.filterWireId && this.consolidateFilter.filterWireId.trim() !== '') {
        params.company_wire_id = this.consolidateFilter.filterWireId.trim()
      }

      if (this.consolidateFilter.filterStatus != 'all') {
        params.company_wire_status = this.consolidateFilter.filterStatus
      }

      if (this.consolidateFilter.filterDate) {
        params.company_wire_start_date = utils.filterDateFrom(this.consolidateFilter.filterDate).toISOString().split('T')[0];
        params.company_wire_end_date = utils.filterDateTo(this.consolidateFilter.filterDate).toISOString().split('T')[0];
      }

      this.$http.get(this.$root.urls.customer__company_wires, { params: params, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    resetToConsolidateFilter() {
      this.filterStatus = this.consolidateFilter.filterStatus
      this.wireId = this.consolidateFilter.filterWireId

      this.filterDate = this.consolidateFilter.filterDate
      this.$refs.filterDate.filterDate = this.consolidateFilter.filterDate
    },
    loadNextPageRecords() {
      if (this.hasNextPage) {
        this.previous_ids = this.previous_ids.concat(this.last_id)
        this.last_id = this.records[this.records.length - 1]['id']
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    loadPreviousPageRecords() {
      if (this.hasPreviousPage) {
        this.last_id = this.previous_ids.pop()
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    moveScrollUp() {
      setTimeout(function () {
        this.$nextTick(function () {
          this.$vuetify.goTo('#table-wires', { duration: 800, offset: 100, easing: 'easeInOutCubic' })
        })
      }.bind(this), 100)
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    selectRecord(record, index) {
      this.selectedRecord = record
      this.selectedIndex = index
      this.loadBankTransactions()
    },
    loadBankTransactions() {
      let successCallback = (response) => {
        if (response.body.data) {
          let mapper = function (scheduled_bank_transaction) {
            let transaction = { ...scheduled_bank_transaction }
            delete transaction.bank_transaction
            let bank_transaction = { ...scheduled_bank_transaction.bank_transaction }
            bank_transaction.scheduled_bank_transaction = transaction
            return bank_transaction
          }
          this.selectedRecord.bank_transactions = response.body.data.map(mapper)
          if (this.selectedRecord.bank_transactions.length === 0) {
            this.transactionsLoaded = 'empty'
          } else {
            this.transactionsLoaded = 'ok'
          }
        } else {
          this.transactionsLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.transactionsLoaded = 'not_authorized'
        } else {
          this.transactionsLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      this.transactionsLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(`${this.$root.urls.customer__company_wires}/${this.selectedRecord.id}/transactions`, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    loadTransactionDetails() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.transactionDetails = response.body.data
          this.dialog = true
        } else {
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      let params = {
        complete: true
      }
      this.$http.get(`${this.$root.urls.customer__scheduled_bank_transactions}${this.selectedTransaction.scheduled_bank_transaction.id}`, { params: params, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    onTransactionClick(record) {
      this.selectedTransaction = record
      this.loadTransactionDetails()
    },
    closeDialog() {
      this.dialog = false
    },
    setFilterDate(filterDate) {
      this.filterDate = filterDate
    },
    resetFilter() {
      this.filterDate = null;
      this.$refs.filterDate.filterDate = null;
      this.filterStatus = 'all'
      this.wireId = null;

      this.consolidateFilter = {
        filterDate: null,
        filterStatus: "all",
        filterWireId: null
      }

      this.reloadRecords()
    },
    updateBankAccount(record) {
      this.set_disable_buttons_handler(record)
      this.openUpdateBankAccountDialog(record)
    },
    updateBankAccountItem() {
      let bank_account = this.bank_account_dialog_record

      if (bank_account.account_type == 'internacional') {
        bank_account.account_type = 'conta-corrente'
      }
      if (['BRL', 'MXN', 'COP'].includes(bank_account.currency)) {
        delete bank_account.bank.swift
      } else {
        delete bank_account.bank.code
      }
      let bank_account_payload = Object.fromEntries(Object.entries(this.bank_account_dialog_record).filter(([_, v]) => v != null))
      if (bank_account_payload.pix_info && bank_account_payload.pix_info.key == "" && bank_account_payload.pix_info.type == "") {
        delete bank_account_payload.pix_info
      }
      const payload = {
        bank_account: bank_account_payload
      }

      let successCallback = (response) => {
        if (response.body.data) {
          this.resetForm()
          this.bank_account_dialog = false
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        if (response.body.errors) {
          let errors = utils.translateErrors(response.body.errors, this.$root.lang)
          this.$set(this, 'errors', errors)
          if (errors.bank && errors.bank.code) this.$set(this.errors, 'bank_code', errors.bank.code)
          if (errors.bank_id) this.$set(this.errors, 'bank_code', errors.bank_id)
          if (errors.bank && errors.bank.ispb) this.$set(this.errors, 'bank_ispb', errors.bank.ispb)
          if (errors.bank && errors.bank.swift) this.$set(this.errors, 'bank_swift', errors.bank.swift)
          if (errors.bank && errors.bank.name) this.$set(this.errors, 'bank_name', errors.bank.name)
          if (errors.code) this.$set(this.errors, 'bank_code', errors.code)
          if (errors.ispb) this.$set(this.errors, 'bank_ispb', errors.ispb)
        }
      }

      this.errors = {}
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.customer__company_wires}/${this.bank_account_wire.id}/update_bank_account`
      this.$http.put(url, payload, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    set_disable_buttons_handler(record) {
      this.$root.$on('company-wire-actions-' + record.id, () => {
        this.company_wire_actions_disabled = true
      })
    },
    showActionButtons(record) {
      return !!record.status && !['success', 'waiting_confirmation', 'canceled'].includes(record.status) && !this.company_wire_actions_disabled
    },
    openUpdateBankAccountDialog(wire) {
      let bank_account = wire.to_bank_account

      this.errors = {}
      if (bank_account.currency == 'BRL') {
        if (String(bank_account.owner_document_number).length == 14) {
          bank_account.owner_document_type = 'cnpj'
        } else {
          bank_account.owner_document_type = 'cpf'
        }
      } else {
        bank_account.account_type = 'internacional'
      }
      this.bank_account_dialog_record = bank_account
      this.bank_account_wire = wire
      this.bank_account_dialog = true
    },
    onConfirm() {
      this.confirmation_action(this.confirmation_params)
    },
    confirmMarkAsSuccess(wire) {
      this.confirmation_title = 'Marcar como sucesso'
      this.confirmation_params = wire
      this.confirmation_action = this.markAsSuccess
      this.confirmation_dialog = true
    },
    filter() {
      this.consolidateFilter.filterWireId = this.wireId
      this.consolidateFilter.filterDate = this.filterDate
      this.consolidateFilter.filterStatus = this.filterStatus
      this.reloadRecords()
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.btn-bg-color {
  color: #fff;
  background-color: var(--secondary-button-background-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/CustomerWireListNew.vue